import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogTrigger,
} from "@/components/ui/dialog";
import { getInitData, logout } from "@/lib/helper";
import { DialogDescription, DialogTitle } from "@radix-ui/react-dialog";
import { RiLogoutCircleLine } from "react-icons/ri";

const LogoutDialog = () => {
  const initData = getInitData();

  return (
    <Dialog>
      <DialogTrigger className="flex flex-row items-center cursor-pointer gap-1 bg-red-50 py-1 px-2 border border-red-200 rounded-2xl">
          <RiLogoutCircleLine  className="text-red-600 text-lg -mr-0.5" />
          <p className="font-medium text-red-600 text-sm">خروج</p>
      </DialogTrigger>
      <DialogContent className=" text-center rounded-2xl py-[25px] sm:px-[30px] gap-y-[30px] ">
        <DialogTitle className="text-base ">
          {initData?.fullName} عزیز، آیا مایلید از سیستم خارج شوید؟
        </DialogTitle>
        <DialogDescription className="hidden"></DialogDescription>
        <div className="flex flex-wrap justify-center gap-[10px]">
          <Button onClick={logout} className="w-full max-w-[130px]">
            بله
          </Button>
          <DialogClose asChild>
            <Button variant="accent" className="w-full max-w-[130px]">
              خیر
            </Button>
          </DialogClose>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default LogoutDialog;
